import React from 'react'
import "./Solutions.css"
import Solution from '../Solution/Solution'
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import { Container } from 'react-bootstrap';
import { Title } from '../../../../Components';

const Solutions = ({ url, section }) => {

    const services = section?.data?.services;

    return (

        <div className='solutions'>
            <Container>
                <Title
                    title={"Explore Our Solutions"}
                    overlay={"Solutions"}
                />
            </Container>
            <div className='solutions-slider'>
                <Splide
                    options={{
                        type: "loop",
                        arrows: true,
                        pagination: false,
                        gap: "15px",
                        perPage: 5,
                        autoWidth: true,
                        autoScroll: {
                            pauseOnHover: true,
                            pauseOnFocus: false,
                            rewind: false,
                            speed: 0.5,
                        },
                    }}
                    extensions={{ AutoScroll }}
                >
                    {services && services.objects.map((service, index) => (
                        <SplideSlide key={index}>
                            <Solution
                                image={url + "/" + service.icon}
                                para={service.description}
                                title={service.name}
                            />
                        </SplideSlide>
                    ))}

                </Splide>
            </div>

        </div>
    )
}

export default Solutions
